import { useHeader } from '@/v1/components/Header';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component to automatically reset header content when location changes
 * This prevents header content from persisting between page transitions
 */
export const HeaderReset: React.FC = () => {
  const { setHeaderContent } = useHeader();
  const location = useLocation();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    // Only reset if we're changing to a different path (not on initial load)
    if (
      previousPathRef.current !== null &&
      previousPathRef.current !== location.pathname
    ) {
      if (setHeaderContent) {
        setHeaderContent(null);
      }
    }

    // Update previous path
    previousPathRef.current = location.pathname;
  }, [location.pathname, setHeaderContent]);

  return null; // This component doesn't render anything
};
